import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {service} from '../redux/service'

interface Props {
  id: number
  handleClose: () => void
}

const Field = ({label, value}: {label: string; value?: string | number | null}) => (
  <div className='col-md-4 mb-3'>
    <div className='text-muted small'>{label}</div>
    <div className='fw-semibold'>{value ?? '-'}</div>
  </div>
)

const ViewFixedDepositRequestDetails = ({id, handleClose}: Props) => {
  const [record, setRecord] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    service
      .getFixedDepositRequestDetail(id)
      .then((res) => setRecord(res.data?.data))
      .catch(() => toast.error('Failed to load fixed deposit request details.'))
      .finally(() => setLoading(false))
  }, [id])

  return (
    <div className='modal show d-block' style={{background: 'rgba(0,0,0,0.5)'}}>
      <div className='modal-dialog modal-xl modal-dialog-scrollable'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Fixed Deposit Request — {record?.full_name || id}</h5>
            <button className='btn-close' onClick={handleClose} />
          </div>
          <div className='modal-body'>
            {loading ? (
              <div className='text-center py-5'>
                <div className='spinner-border text-primary' />
              </div>
            ) : !record ? (
              <div className='alert alert-danger'>Request not found.</div>
            ) : (
              <div className='row'>
                <Field label='Full Name' value={record.full_name} />
                <Field label='Account Number' value={record.account_number} />
                <Field label='Mobile Number' value={record.mobile_number} />
                <Field label='Branch' value={record.branch?.title} />
                <Field label='FD Type' value={record.fd_type?.title} />
                <Field
                  label='Tenure'
                  value={record.fd_tenure ? `${record.fd_tenure.tenure} ${record.fd_tenure.tenure_by}` : '-'}
                />
                <Field label='Currency' value={record.fd_currency?.title} />
                <Field label='Deposit Amount' value={record.deposit_amount} />
                <Field label='Interest Rate' value={record.interest_rate} />
                <Field label='Account Status' value={record.account_status} />
                <Field label='Application Step' value={record.application_step} />
                <Field label='Request Code' value={record.request_code} />
                <Field label='Submitted At' value={record.submission_date_time || record.created_at} />
              </div>
            )}
          </div>
          <div className='modal-footer'>
            <button className='btn btn-secondary btn-sm' onClick={handleClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewFixedDepositRequestDetails
